<div class="page-content">

  <ng-container>

    @if (entorno !== 'Production') {
      <div class="slot-environment" [ngClass]="{'mobileDesign': isMobile}">{{ entorno | translate }}</div>
    }

    <mat-toolbar class="toolbar">

      <!--                    TOOLBAR FOR PHONE                    -->
      <!-- solo es visible en dispositivos móviles -->
      @if (isMobile) {
        <button mat-icon-button (click)="sidenav.toggle()" class="iconMenu">
          <mat-icon>menu</mat-icon>
        </button>
        <div>
          <img src="assets/imagenes/icons/iconos2-02.svg" class="logo">
        </div>
        <span class="example-spacer"></span>

        @if (!Munselect) {
          <div class="container-mat-spinner-icon-location">
            <mat-spinner [diameter]="25" color="accent"></mat-spinner>
          </div>
        }
        @if (Munselect && ListMun) {
          <button mat-icon-button [matMenuTriggerFor]="menu"
            (click)="refreshCityList()" class="iconMenu">
            <mat-icon>location_on</mat-icon>
          </button>
        }

        @if (!Munselect) {
          <div class="container-mat-spinner-icon-person">
            <mat-spinner [diameter]="25" color="accent"></mat-spinner>
          </div>
        }
        @if (Munselect) {
          <button mat-icon-button [matMenuTriggerFor]="settings" class="iconMenu">
            <mat-icon>person</mat-icon>
          </button>
        }
      }
      <!-- ============================== -->

      <!--                    TOOLBAR FOR DESKTOP                     -->
      <!-- solo es visible en dispositivos con dimensiones de escritorio  -->
      @if (!isMobile) {

        <img [ngClass]="{ 'logoMarginLeft': entorno !== 'Production' }" src="assets/imagenes/icons/UP-11.svg"
          class="logo" />

          <mat-nav-list class="list-horizontal" [ngClass]="{ 'module-nav--blocked': !appState }">
            @for (header of headers; track header) {
              @if (header.hasAccess) {
                <a [ngClass]="{'active-list-item': headerSelect === header.type}" mat-list-item
                  [routerLink]="headerSelect === header.type ? null : [header.routerLink]"
                  (click)="onModuleHeaderClick(header.type, $event)">
                  <span matLine class="textoItemMenu">{{header.name | translate}} </span>
                  @if (headerSelect === header.type) {
                    <mat-icon class="icon-active">expand_more</mat-icon>
                  }
                </a>
              }
            }

            <!-- Administrar: se muestra según módulos (paquetes) -->
            @if (hasModuleAccess(3)) {
              <a [ngClass]="{'active-list-item': headerSelect === 3}" mat-list-item
                [routerLink]="headerSelect === 3 ? null : ['admin']"
                (click)="onModuleHeaderClick(3, $event)">
                <span matLine class="textoItemMenu">{{ 'Administrar' | translate}}</span>
                @if (headerSelect === 3) {
                  <mat-icon class="icon-active">expand_more</mat-icon>
                }
              </a>
            }

            @if (hasModuleAccess(8)) {
              <a [ngClass]="{'active-list-item': headerSelect === 8}" mat-list-item
                [routerLink]="headerSelect === 8 ? null : ['developer']"
                (click)="onModuleHeaderClick(8, $event)">
                <span matLine class="textoItemMenu">{{ 'Developer' | translate}}</span>
                @if (headerSelect === 8) {
                  <mat-icon class="icon-active">expand_more</mat-icon>
                }
              </a>
            }

          </mat-nav-list>

          <span class="example-spacer"></span>

          <div class="container-btns">

            <mat-divider class="mat-divider-btns" [vertical]="true"></mat-divider>

            @if (municipioUserSlider) {
              <div class="slide-div">
                <mat-slide-toggle [(ngModel)]="showCounterMunicipioVirtual" (change)="toggleAllSelection()"
                  color="primary" matTooltip="{{ 'municipio_virtual' | translate }}"
                  matTooltipClass="colortooltip">
                  @if (!showCounterMunicipioVirtual) {
                    <div class="textMenuSlider" id="id_text_uppercase">
                      {{ 'municipio_virtual' | translate }}
                    </div>
                  }
                </mat-slide-toggle>
              </div>
            }

            <div class="btnMunicipio">
              @if (Munselect && ListMun) {
                <button id="id_text_uppercase" class="btn-name-city" mat-button [matMenuTriggerFor]="menu"
                  (click)="refreshCityList(); positionCityInTheCitiesMenu()" [matTooltip]="Munselect.Nombre"
                  matTooltipClass="tooltipMunicipio">
                  {{ showCounterMunicipioVirtual ? ('municipio_virtual' | translate) : Munselect.Nombre }}
                </button>
              }
            </div>
          </div>

        }

        @if (!isMobile) {
          @if (!Munselect) {
            <button mat-button>
              <mat-spinner [diameter]="25"></mat-spinner>
            </button>
          }
        }

            @if (!isMobile) {
                <button mat-button [matMenuTriggerFor]="settings"
                    class="example-icon favorite-icon btnUser">
                    @if (nameUser) {
                        <div class="userButton">
                            <mat-icon matListItemAvatar>person</mat-icon>
                            <span class="textUser">
                                <span class="textUser-name">{{nameUser}}</span>
                                @if (ListDataUSer) {
                                    <small class="textUser-role">
                                        {{ userRolNameSig() ?? '---' | translate }}
                                    </small>
                                }
                            </span>
                        </div>
                    } @else {
                        <mat-spinner [diameter]="25"></mat-spinner>
                    }
                </button>
            }

        <!-- Ayuda del módulo -->
        <app-consultar-ayuda class="hidden" #ayudaGeneral></app-consultar-ayuda>
        
        <button matTooltip="{{ ('ayudas' | translate ) }}" mat-icon-button (click)="ayudaGeneral.consultarAyuda()">
            <mat-icon class="material-symbols-outlined">help</mat-icon>
        </button>

        <div>
          <button class="misAplicaciones" mat-icon-button (click)="viewApplications()">
            <mat-icon class="material-symbols-outlined">grid_view</mat-icon>
          </button>
        </div>

        <!-- ============================== -->

      </mat-toolbar>

    </ng-container>

    <!--                    SUBMENU DESKTOP                    -->
    <!-- solo es visible en dispositivos con dimensiones de escritorio  -->
    <div>
      <ng-container>
        @if (!isMobile) {
          <mat-toolbar class="subMenu">

            @for (rt of ChildRoutes; track rt) {

              <div class="submenu-wrapper">

                <!-- BOTONES NORMALES -->
                @if (rt.path !== 'paneles') {
                  <button mat-button [routerLink]="getRoute(rt.path)"
                    routerLinkActive="active-tab">

                    {{ rt.path | translate }}
                  </button>
                }

                <!-- BOTÓN PANELES (SOLO TOGGLE) -->
                @if (rt.path === 'paneles') {
                  <button mat-button class="paneles-btn"
                    (click)="togglePaneles($event)">

                    <span class="paneles-text">{{ rt.path | translate }}</span>
                    <mat-icon class="paneles-icon">expand_more</mat-icon>
                  </button>
                }

                <!-- SUB-SUBMENÚ -->
                @if (rt.path === 'paneles' && showPanelesSubmenu) {
                  <div class="paneles-flyout">

                    @for (p of panelesChildRoutes; track p) {
                      <button mat-button class="paneles-item"
                        [routerLink]="['/developer/paneles', p.path]" (click)="selectPanel(p.path)"
                        [ngClass]="{ 'paneles-item-active': selectedPanelPath === p.path }">

                        {{ p.path | translate }}
                      </button>
                    }

                  </div>
                }

              </div>

            }

          </mat-toolbar>
        }



      </ng-container>
    </div>
    <!-- ============================== -->
    @if (!isMobile) {
      @if (appState) {
        <div class="app-container animate__animated animate__fadeIn animate__faster">
          <router-outlet></router-outlet>
        </div>
      }
    }

    <!--                    SIDENAV PHONE                    -->
    <!-- solo es visible en dispositivos móviles -->
    @if (isMobile) {
      <mat-sidenav-container class="app-sidenav-container">
        <mat-sidenav #sidenav mode="side">

          <div class="sidenavItem">

            <button mat-button class="menuNav" [matMenuTriggerFor]="route" [disabled]="!appState" (click)="showHeaders()">
              {{ getModuleTranslationKeyForMobile(headerSelect) | translate }}
              <mat-icon class="material-symbols-outlined"
              [class.showOrHide]="showOrHide">keyboard_arrow_down</mat-icon>
            </button>

            <mat-menu #route="matMenu" (closed)="showHeaders()">
              @for (header of headers; track header) {
                @if (header.hasAccess) {
                  <button [ngClass]="{'active-list-item': headerSelect === header.type}" mat-menu-item
                    [routerLink]="headerSelect === header.type ? null : [header.routerLink]"
                    (click)="onModuleHeaderClick(header.type, $event)">
                    {{header.name | translate}}
                  </button>
                }
              }

              @if (hasModuleAccess(3)) {
                <button
                  [ngClass]="{'active-list-item': headerSelect === 3}" mat-menu-item
                  [routerLink]="headerSelect === 3 ? null : ['admin']"
                  (click)="onModuleHeaderClick(3, $event)">
                  {{ 'Administrar' | translate}}
                </button>
              }

            </mat-menu>

            <mat-nav-list>
              @for (rt of ChildRoutes; track rt) {
                <mat-list-item (click)="sidenav.close()"
                  [routerLink]="getRoute(rt.path)" routerLinkActive="active-tab">
                  <a matLine> {{ rt.path | translate}}</a>
                  <button mat-icon-button>
                    <mat-icon>chevron_right</mat-icon>
                  </button>
                  <mat-divider></mat-divider>
                </mat-list-item>
              }
            </mat-nav-list>
          </div>

        </mat-sidenav>

        <div (click)="closeSidenav()">
          @if (appState && isMobile) {
            <router-outlet class="animate__animated animate__fadeIn animate__faster"></router-outlet>
          }
        </div>
      </mat-sidenav-container>
    }
    <!-- ============================== -->
  </div>

  <!-- Componente que tiene el Sweetalert para mostrar la versión de la app -->
  <app-acerca-de></app-acerca-de>

  <mat-menu panelId="munMenu" #menu="matMenu" class="menuMunicipios">
    <ng-template matMenuContent>
      <div class="form__group">
        <mat-form-field class="full-width" subscriptSizing="dynamic" appearance="outline"
          (click)="$event.stopPropagation();">
          <mat-label>{{ 'buscar' | translate }}</mat-label>
          <input autocomplete="off" matInput [formControl]="citySearchControl" />
        </mat-form-field>
      </div>

      <div class="menu-container">
        @if (results && results.length > 0) {

          @if (showCounterMunicipioVirtual) {
            <mat-list>
              <mat-list-item>
                <mat-checkbox [checked]="selectedMunicipios.length === maxMunicipiosSelected"
                  (change)="toggleAllSelectionAll()" color="primary">
                  <div class="textMenu">
                    {{ 'todos' | translate }}
                    <span>({{ selectedMunicipios.length }}/{{ maxMunicipiosSelected }})</span>
                  </div>
                </mat-checkbox>
              </mat-list-item>

                        @for (mun of results | sortListMunicipalities: selectedMunicipios: 'firstMunicipalitiesSelectedAndAsc'; track mun) {
                            <mat-list-item role="listitem" [id]="'municipio-' + mun.IdMunicipio">
                                <mat-checkbox [checked]="selectedMunicipios.includes(mun.IdMunicipio)"
                                    [disabled]="(!selectedMunicipios.includes(mun.IdMunicipio) && selectedMunicipios.length >= maxMunicipiosSelected) || (selectedMunicipios.length === 1 && selectedMunicipios.includes(mun.IdMunicipio))"
                                    (change)="onMunicipioCheckboxChange(mun)"
                                    color="primary">
                                    <div class="textMenu">
                                        {{ mun.Nombre }}
                                    </div>
                                </mat-checkbox>
                            </mat-list-item>
                        }
                    </mat-list>
                } @else {
                    <mat-selection-list #city [multiple]="false" (selectionChange)="onMunicipioSelectionChange($event)">
                        @for (mun of results | sortListMunicipalities: selectedMunicipios: 'firstMunicipalitiesSelectedAndAsc': citySearchControl.value; track mun) {
                            <mat-list-option [selected]="Munselect.IdMunicipio === mun.IdMunicipio"
                                [disabled]="Munselect.IdMunicipio === mun.IdMunicipio" [value]="mun">
                                <div class="textMenu">
                                    {{mun.Nombre}}
                                </div>
                            </mat-list-option>
                        }
                    </mat-selection-list>
                }
            }

        @if (results && results.length === 0) {
          <div class="no-results-div">
            <span>{{ 'sin-resultados' | translate }}</span>
          </div>
        }
      </div>
    </ng-template>
  </mat-menu>

  <mat-menu #settings="matMenu">
    <button mat-menu-item (click)="OpenProfile()">
      <mat-icon class="color-icon-settings">person</mat-icon>
      <span>{{'Perfil_de_Usuario' | translate}}</span>
    </button>

    <button appValidateRoles [idRoles]="[6,7]" mat-menu-item (click)="openDialgCity()">
      <mat-icon class="color-icon-settings">build</mat-icon>
      <span>{{'Configurar_Municipio' | translate}}</span>
    </button>

    <a target="_blank" #manualUrl download hidden>enlace_descarga_manual</a>

    <button mat-menu-item (click)="downloadUserManual()">
      <mat-icon class="color-icon-settings">book</mat-icon>
      <span>{{'manual' | translate}}</span>
    </button>

    <button mat-menu-item (click)="openDefaultRoutesDialog()">
      <mat-icon class="color-icon-settings" fontSet="material-symbols-outlined">dashboard_customize</mat-icon>
      <span>{{'rutas-predeterminadas' | translate}}</span>
    </button>

    <button mat-menu-item routerLink="/preguntas-frecuentes">
      <mat-icon class="color-icon-settings">article_shortcut</mat-icon>
      <span>{{'preguntas_frecuentes' | translate}}</span>
    </button>

    <button mat-menu-item (click)="showAbout()">
      <mat-icon class="color-icon-settings">help</mat-icon>
      <span>{{'Acerca_de' | translate}}</span>
    </button>

    <button mat-menu-item [matMenuTriggerFor]="Idiomas">
      <mat-icon class="color-icon-settings">translate</mat-icon>
      <span>{{'ConfIdiona' | translate}}</span>
    </button>

    <mat-menu #Idiomas="matMenu">
      @for (lang of LANGS; track $index) {
        <button
          mat-menu-item
          (click)="selectLanguage(lang)"
          [ngClass]="{ 'active-list-item': language === lang }">
          <mat-icon class="flag-icon" [svgIcon]="lang"></mat-icon>
          {{ lang | translate | uppercase }}
        </button>
      }
      @for (lang of LANGS; track lang) {
      }
    </mat-menu>


    <button mat-menu-item (click)="closeSession()">
      <mat-icon class="color-icon-settings">exit_to_app</mat-icon>
      <span>{{'Salir' | translate}}</span>
    </button>
  </mat-menu>